import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { Observable } from 'rxjs';
import { MatRadioChange } from '@angular/material/radio';
import { PaycheckErrorComponent } from '../paycheckError/paycheckError.component';

export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-add3cforPcc',
  templateUrl: './add3cforPcc.component.html',
  styleUrls: ['./add3cforPcc.component.scss'] 
})



export class Add3cforPccComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
 
  folderId:number=0;
  getTagListResponseHolder: any;
  formDialog: FormGroup;

  OfficeIDList: any=[];
  myOfficeID: any;   
  spinner:boolean=false; 

  //@Input() mainModuleName: string;
  @Output() closeShareFile3c = new EventEmitter<boolean>();
  menuModulesList:any=[]=[];
  folderID:number=0;

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<Add3cforPccComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService,private loaderService: LoaderService, ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
    
  }  
  
  ngOnInit(): void {    
    if(this.data)
    this.showAddButton=true;
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
      this.folderID = SelectedCore[0].folderID;
    }

    // SelectedContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    // if (SelectedContact.length > 0) {
    //   this.ContactShowName = SelectedContact[0].orgModuleName;
    // }

    // SelectedCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    // if (SelectedCompany.length > 0) {
    //   this.CompanyShowName = SelectedCompany[0].orgModuleName;
    // }   
  }
      
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";

  ShowAttchedToCore: boolean = true;
  ShowAttchedToContact: boolean = false;
  ShowAttchedToCompany: boolean = false;


  attachedToCoreList: any = [] = [];
  attachedToContactList: any = [] = [];
  attachedToCompanyList: any = [] = [];


  attachedToSelectedCore: any = [] = [];
  attachedToSelectedContact: any = [] = [];
  attachedToSelectedCompany: any = [] = [];

  checkedAttachCore: boolean = true;
  checkedAttachContact: boolean = false;
  checkedAttachCompany: boolean = false;

  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;
  roleIdList: any = [];
  showAddButton = false;
  timeout = null;  
  selectedCoreId:number=0;
  selectedContactId:number=0;
  selectedCompanyId:number=0;

  formData: FormData;
  selectedFileArray:any=[]=[];
  selecteddocumentCategory: number = 0;
  paycheckErrorList: any = [] = [];
  isReCreate: boolean = false;

  selectCCC($event: MatRadioChange) {
    this.stateCtrl.reset();
    this.showAddButton=true;
    if ($event.value === 'Core') {
      this.ShowAttchedToCore = true;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = true;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = false;      
    }
    if ($event.value === 'Contact') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = true;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = false;
      this.checkedAttachContact = true;
      this.checkedAttachCompany = false;     
    }
    if ($event.value === 'Company') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = true;

      this.checkedAttachCore = false;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = true;     
    }    
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];
  }


 //======================Core============================//

  searchCore(val) {
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }

  transactionID3C:any;

  attchedToCoreSelected(coreSelected: any) {
    var checkCore = [];
    this.stateCtrl.setValue('');
    var reqmodel={     
      DatabaseID : Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      coreID : Number(coreSelected.coreID),
      FolderId : Number(this.folderID),
      subFolderID : Number(coreSelected.typeID),   
      UserID : this.currentUser.UID,
      officeID : this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    } 
    this.settingsService.getCoreUserDetails(reqmodel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          //sessionStorage.setItem("PCCPatientID", response.data.patientId);
          //sessionStorage.setItem("PCCPendingPatientID", response.data.pendingPatientId);

          if(response.data.patientId ==null && response.data.pendingPatientId ==null){
            this.toastr.warning("Submit the patient in PCC and try again.")
            return;
          }
          if(response.data.patientId ==null && response.data.pendingPatientId !=null){
             this.toastr.warning("Please ask respective facility to convert the pending patient to an actual patient and then try again.")
              return;
          }
        //   if((sessionStorage.getItem("PCCPatientID") == 'null' || sessionStorage.getItem("PCCPatientID") == 'undefined' || sessionStorage.getItem("PCCPatientID") == '') && (sessionStorage.getItem("PCCPendingPatientID") == 'null' || sessionStorage.getItem("PCCPendingPatientID") == 'undefined' || sessionStorage.getItem("PCCPendingPatientID") == '')) {
        //     this.toastr.warning("Submit the patient in PCC and try again.")
        //     return false;
        //   }

        //  if(sessionStorage.getItem("PCCPatientID") == 'null' || sessionStorage.getItem("PCCPatientID") == 'undefined' || sessionStorage.getItem("PCCPatientID") == '') {
        //    this.toastr.warning("Please ask respective facility to convert the pending patient to an actual patient and then try again.")
        //    return false;
        //  }

          checkCore = this.attachedToSelectedCore;
          if (checkCore.length == 0) {
            this.selectedCoreId = coreSelected.coreID;
            this.transactionID3C = coreSelected.transactionID;
            var shortName = "";
            shortName = coreSelected.name.match(/\b(\w)/g).join('');
            var ReqModel = {
              coreID: coreSelected.coreID,
              email: coreSelected.email,
              name: coreSelected.name,        
              transactionID: coreSelected.transactionID,
              img: coreSelected.imageUrl,       
              shortName: shortName,
            }
            this.attachedToSelectedCore.unshift(ReqModel);
            this.stateCtrl.reset();
            if (this.attachedToSelectedCore.length > 0) {
              this.showAddButton = false;
            } else {
              this.showAddButton = true;
            }   
        }  
        }
      } else {
        
      }
    });
   
 }

 

  attchedToRemoveCore(item: any) {   
    const index = this.attachedToSelectedCore.indexOf(item);
    if (index >= 0) {
      this.attachedToSelectedCore.splice(index, 1);
    }
    if (this.attachedToSelectedCore.length == 0) {
      this.stateCtrl.reset();
      this.showAddButton = true;
    }     
  }



  //======================Contact============================//

  searchContacts(val) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }

  getsearchContact(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToContactList = response.data;
        } else {
          this.attachedToContactList = [];
        }
      }
    })
  }


  attchedToContactSelected(contactSelected: any) {
    var checkContact = [];
    this.stateCtrl.setValue('');
    checkContact = this.attachedToSelectedContact;
    if (checkContact.length == 0) {
      this.selectedContactId = contactSelected.contactID;
      var shortName = "";
      shortName = contactSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,      
        transactionID: contactSelected.transactionID,
        img: contactSelected.imageUrl,       
        shortName: shortName,
      }
      this.attachedToSelectedContact.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedContact.length > 0) {
        this.showAddButton = false;
      } else {
        this.showAddButton = true;
      }   
  }  
 }



  attchedToRemoveContact(item: any) {
    const index = this.attachedToSelectedContact.indexOf(item);
    if (index >= 0) {
      this.attachedToSelectedContact.splice(index, 1);
    }
    if (this.attachedToSelectedContact.length == 0) {
      this.stateCtrl.reset();
      this.showAddButton = true;
    }     
  }





   //======================Company============================//

   searchCompany(val) {
    if (val.length >= 2) {
      this.attachedToCompanyList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCompany(val)
        }, 500);
      } else {
        this.attachedToCompanyList = [];
      }
    }
  }

  getsearchCompany(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCCC.length > 0) {
      this.CompanyfolderID = SelectedCCC[0].folderID;
    }

    this.roleIdList = [];

    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CompanyfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCompany(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCompanyList = response.data;
        } else {
          this.attachedToCompanyList = [];
        }
      }
    })
  }


  attchedToCompanySelected(companySelected: any) {
    var checkCompany = [];
    this.stateCtrl.setValue('');
    checkCompany = this.attachedToSelectedCompany;
    if (checkCompany.length == 0) {
      this.selectedCompanyId = companySelected.companyID;
      var shortName = "";
      shortName = companySelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        companyID: companySelected.companyID,
        email: companySelected.email,
        name: companySelected.name,       
        transactionID: companySelected.transactionID,
        img: companySelected.imageUrl,       
        shortName: shortName,
      }
      this.attachedToSelectedCompany.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCompany.length > 0) {
        this.showAddButton = false;
      } else {
        this.showAddButton = true;
      }   
  }  
  }


  attchedToRemoveCompany(item: any) {
    const index = this.attachedToSelectedCompany.indexOf(item);
    if (index >= 0) {
      this.attachedToSelectedCompany.splice(index, 1);
    }
    if (this.attachedToSelectedCompany.length == 0) {
      this.stateCtrl.reset();
      this.showAddButton = true;
    }   
  }

  UploadDocumenttoPCC(){
    var SharedSelectedFile = [];
    var SharedSelectedFileNew = [];
    SharedSelectedFile = this.data.files.filter((s) => s.itemType == 2);
    if(SharedSelectedFile.length>0){
      for (let i = 0; i < SharedSelectedFile.length; i++) {
        var placeholderType = SharedSelectedFile[i].itemType;
        if (placeholderType == 2) {
          const fileManagerItemID = SharedSelectedFile[i].id;
          SharedSelectedFileNew.push(fileManagerItemID);         
        }
      }
    }
    
    var ReqModels = {
    cid: Number(this.selectedCoreId),
    cType: 1, // for Core
    fileIDs: SharedSelectedFileNew,   
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    officeID: Number(this.myOfficeID),
    databaseID: Number(this.databaseId),       
  };
  //this.close();
  this.settingsService.addDocumentFileManagerTo3C(ReqModels).subscribe((response) => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        if(this.responseHolder.data.docs.length>0){
          this.UploadDocumenttoPCC1(this.responseHolder.data.docs);
        }        
        //this.loaderService.hide();          
      }
    } else {
     // this.loaderService.hide();
    }
  });
  }


  UploadDocumenttoPCC1(record) {
    // if (sessionStorage.getItem("PCCPatientID") == 'null' || sessionStorage.getItem("PCCPatientID") == 'undefined' || sessionStorage.getItem("PCCPatientID") == '') {
    //   this.toastr.warning("Please ask respective facility to convert the pending patient to an actual patient and then try again.")
    //   return false;
    // }
    this.selectedFileArray=[];
    this.selectedFileArray = record;
    this.loaderService.show();
    let DocumentList = [

    ];
    for (let i = 0; i < this.selectedFileArray.length; i++) {
      let obj = this.selectedFileArray[i];
     // if (this.selectedFileArray[i].selectedDocument.placeholderType == 1 && this.selectedFileArray[i].selectedDocument.formType == 0 && this.selectedFileArray[i].selectedDocument.isDocumentUploadedToPCC == false) {
        let DocumentDetail = {
          'PlaceholderId': obj.placeholderID,
          'ProjectId': 0,//obj.selectedDocument.projectID,
          'BlobURL': this.data.files[i].selectedDocument.azureblobPath,//obj.selectedDocument.azureblobPath,
          'PlaceholderType': 1,//obj.selectedDocument.placeholderType,
          'FileName': this.data.files[i].selectedDocument.name,//obj.selectedDocument.name,
          'FormType': 0,//obj.selectedDocument.formType,
          'CoreDocumentID': obj.documentID
        }
        DocumentList.push(DocumentDetail);
      //}
     
      // else {
      //   this.toastr.warning('Document ' + this.selectedFileArray[i].selectedDocument.name + ' is already uploaded to PointClickCare, so this document will be skipped.', '', {
      //     timeOut: 3000,
      //   });
      // }
    }   
    if (DocumentList.length == 0) {
      this.loaderService.hide();
      this.close();
      return;
    }
    
    let ReqModel = {
      'transactionID': Number(this.selectedCoreId),//sessionStorage.getItem('transactionID'),
      'userID': this.currentUser.UID,
      'organizationID': Number(this.organizationId),
      'officeID': Number(this.myOfficeID),
      'databaseID': Number(this.databaseId),
      'documentCatrgoryId': Number(this.data.selecteddocumentCategory),
      'documentList': DocumentList
    };
    //this.close();
    this.settingsService.UploadDocumenttoPCC(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();         
          let quota=this.responseHolder.data.elements.find(m=>m.type==1);
            if(quota!=undefined && quota.code=='100'){                
                var obj = {
                  name: "Temporary API Service Unavailability",
                  code: "API will start functioning at "+new Date(quota.xQuotaTimeToResetDateTime),
                  description: quota.detail,
                }
                this.paycheckErrorList.push(obj);
                this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
                return;
               }
            this.dialogRef.close('Added');
            this.toastr.success('Document successfully uploaded to PointClickCare', '', {
            timeOut: 3000,
          });         
        }
      } else {
        this.loaderService.hide();
      }
    });
  }
 

  showPaycheckError(title: any = null) {
    const dialogRef = this.dialog.open(PaycheckErrorComponent, {
      data: {
        list: this.paycheckErrorList,
        title: title,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isReCreate = result;
      }
    });
  }
  
  close() {   
    this.dialog.closeAll();
  }

}
